export const getMenuData = [
  {
    category: true,
    title: 'Dashboard',
  },
  {
    title: 'Dashboard',
    key: 'dashboard',
    icon: 'fas fa-chart-bar',
    url: '/dashboard',
    children: [
      {
        title: 'Dashboard Umum',
        key: 'dashboardUmum',
        url: '/dashboard/umum',
        roles: ['all'],
      },
      {
        title: 'Dashboard Tagrisso',
        key: 'dashboardTagrisso',
        url: '/dashboard/tagrisso',
        roles: ['admin', 'tagrisso', 'astrazeneca'],
      },
      {
        title: 'Dashboard Lynparza',
        key: 'dashboardLynparza',
        url: '/dashboard/lynparza',
        roles: ['admin', 'lynparza', 'astrazeneca'],
      },
      {
        title: 'Dashboard Faslodex',
        key: 'dashboardFaslodex',
        url: '/dashboard/faslodex',
        roles: ['admin', 'faslodex', 'astrazeneca'],
      },
      {
        title: 'Dashboard Imfinzi',
        key: 'dashboardImfinzi',
        url: '/dashboard/imfinzi',
        roles: ['admin', 'imfinzi', 'astrazeneca'],
      },
      {
        title: 'Dashboard Calquence',
        key: 'dashboardCalquence',
        url: '/dashboard/calquence',
        roles: ['admin', 'calquence', 'astrazeneca'],
      },
      {
        title: 'Latest Patient',
        key: 'dashboardLatest',
        url: '/dashboard/latest',
        roles: ['admin', 'astrazeneca'],
      },
    ],
  },
  {
    category: true,
    title: 'Entitas',
    roles: ['all'],
  },
  {
    title: 'Pasien',
    key: 'Pasien',
    icon: 'fas fa-users',
    url: '/pasien',
    roles: ['all'],
  },
  {
    title: 'Himponi',
    key: 'Himponi',
    icon: 'fas fa-users',
    url: '/pasien/himponi',
    roles: ['all'],
  },
  {
    title: 'Verifikator',
    key: 'Verifikator',
    icon: 'fas fa-user-check',
    url: '/verifikator',
    roles: ['admin', 'verifikator', 'astrazeneca'],
  },
  {
    title: 'Dokter',
    key: 'Dokter',
    icon: 'fas fa-user-nurse',
    url: '/dokter',
    roles: ['admin', 'astrazeneca', 'apl'],
    // children: [
    //   {
    //     title: 'List Dokter',
    //     key: 'List Dokter',
    //     icon: 'fe fe-list',
    //     url: '/dokter',
    //   },
    //   {
    //     title: 'Tambah Dokter',
    //     key: 'Tambah Dokter',
    //     icon: 'fe fe-plus',
    //     url: '/dokter/tambah',
    //   },
    // ],
  },
  {
    title: 'Farmasi',
    key: 'Farmasi',
    icon: 'fas fa-clinic-medical',
    url: '/farmasi',
    roles: ['admin', 'astrazeneca', 'apl'],
  },
  {
    title: 'Laboratorium',
    key: 'Laboratorium',
    icon: 'fas fa-flask',
    url: '/laboratorium',
    roles: ['admin', 'astrazeneca'],
  },
  {
    category: true,
    title: 'Program',
    roles: ['admin', 'astrazeneca'],
  },
  {
    title: 'Obat',
    key: 'Obat',
    icon: 'fas fa-pills',
    url: '/obat',
    roles: ['admin', 'astrazeneca'],
  },
  {
    title: 'Voucher',
    key: 'Voucher',
    icon: 'fas fa-ticket-alt',
    url: '/voucher',
    roles: ['admin', 'astrazeneca'],
  },
  {
    title: 'Artikel',
    key: 'Artikel',
    icon: 'far fa-newspaper',
    url: '/artikel',
    roles: ['admin', 'astrazeneca'],
  },
  {
    title: 'Video Vertical',
    key: 'VideoVertical',
    icon: 'fa fa-video',
    url: '/video',
    roles: ['admin', 'astrazeneca'],
  },
  // {
  //   title: 'NPS',
  //   key: 'NPS',
  //   icon: 'far fa-star',
  //   url: '/nps',
  //   roles: ['admin', 'astrazeneca'],
  // },
  {
    category: true,
    title: 'Survey',
    roles: ['admin', 'astrazeneca'],
  },
  {
    title: 'Pertanyaan Survey',
    key: 'PertanyaanSurvey',
    icon: 'fa fa-poll',
    url: '/survey',
    roles: ['admin', 'astrazeneca'],
  },
]

// {/* <i class="fa-solid fa-square-poll-horizontal"></i> */}
